import { Device } from '@smart-tv/components/player/player-devices/types';
import getUnixDate from '@smart-tv/utils/date/get-unix-date';
import { PlaybackDevicesNetworkModel } from '@norlys-a-s/norlys-play-kmm';
import { kmm } from './kmm';

interface PlaybackDevicesResponse {
  devices: Device[];
  texts: {
    body1: string;
    body2: string;
    headline: string;
  };
}

interface GetPlaybackDevicesParams {
  sid?: number;
  mediaId?: number;
}

const mapKmmDeviceToDevice = (device: PlaybackDevicesNetworkModel.DeviceNetworkModel): Device => {
  return {
    active: device.isActive ?? false,
    lastUsedDate:
      device.lastUsedAtEpochSeconds != null ? getUnixDate(device.lastUsedAtEpochSeconds) : null,
    name: device.name ?? '',
    uid: device.uid ?? ''
  };
};

export async function getPlaybackDevices(
  params: GetPlaybackDevicesParams
): Promise<PlaybackDevicesResponse> {
  const response = await kmm((repo) => repo.getPlaybackDevices(params.sid, params.mediaId), false);

  const devices = (response.devices ? response.devices.asJsReadonlyArrayView() : []).map(
    mapKmmDeviceToDevice
  );

  return {
    devices,
    texts: {
      body1: response.body1 ?? '',
      body2: response.body2 ?? '',
      headline: response.headline ?? ''
    }
  };
}

export default getPlaybackDevices;
